export default "__VITE_ASSET__D4sg2v84__"